/** global gsap, Flickity */
import BurgerButton from './components/burger-button';
import MainMenu from './components/main-menu';
import ScrollToTop from './components/scroll-to-top';
// import Lenis from '@studio-freight/lenis';
import Slider from './components/slider';
import ChangePositions from './components/change-position';
import PhotoSwipeTheme from './components/photoswipe';
import Datepickers from './components/datepicker';
import MouseDrag from './components/mouse-drag';
import ReadMoreToggler from './components/read-more-toggler';
import MasonryGallery from './components/masonry-gallery';
import AnimatedWidth from './components/animated-width';
import CompareImage from './components/image-compare-viewer';
import Header from './components/header';
import Video from './components/video';
import Preloader from './components/preloader';
import Egg from './components/egg';
import FadeAnimation from './components/fade-animation';
import ScrollInAnimation from './components/scroll-animation';
// import simpleParallax from './components/simpleParallax';
import ScrollAnimations from './components/scrollAnimations';
import EmbedVideo from './components/yt-video';

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

// Get siblings
// https://www.javascripttutorial.net/javascript-dom/javascript-siblings/
const getSiblings = function(e) {
	// for collecting siblings
	let siblings = [];

	// if no parent, return no sibling
	if(!e.parentNode) {
		return siblings;
	}

	// first child of the parent node
	let sibling  = e.parentNode.firstChild;

	// collecting siblings
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== e) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}
	return siblings;
}

const App = {
	init() {
		window.addEventListener('resize', () => {
			let vh = window.innerHeight * 0.01;
			document.querySelectorAll('.vh').forEach(function(el) {
				el.style.setProperty('--vh', vh + 'px');
			});
		});

		const burgerButton = new BurgerButton();
		const mainMenu = new MainMenu();
		const scroll = new ScrollToTop();
		const changePositions = new ChangePositions();
		const header = new Header();

		Array.from(document.querySelectorAll('[data-smooth-scroll]')).map(el => new ScrollAnimations(el));
		// new simpleParallax(document.querySelectorAll('[data-smooth-scroll]'), {
		// 	delay: 1,
		// 	transition: 'cubic-bezier(0,0,0,1)'
		// });

		const photoswipe = document.getElementById('gallery-marquee-container');
		if (photoswipe) {
			const photoSw = new PhotoSwipeTheme(photoswipe);
		}

		const photoswipeGallery = document.getElementById('masonry-gallery');
		if (photoswipeGallery) {
			const photoSwGal = new PhotoSwipeTheme(photoswipeGallery);
		}

		const sliders = document.querySelectorAll('.slideshow.with-custom-buttons');
		if (sliders) {
			sliders.forEach(sl => new Slider(sl));
		}

		if (document.getElementById('checkin-picker') && document.getElementById('checkout-picker')) {
			let checkInOutPickers = new Datepickers(document.getElementById('checkin-picker'), document.getElementById('checkout-picker'));
		}

		if (document.querySelector('.mouse-drag')) {
			let mouseDrag = new MouseDrag();
		}

		Array.from(document.querySelectorAll('.read-more-toggle-link')).map(el => new ReadMoreToggler(el));

		Array.from(document.querySelectorAll('.masonry-gallery')).map(el => new MasonryGallery(el));

		Array.from(document.querySelectorAll('.animated-width')).forEach(el => new AnimatedWidth(el));


		// Offers tabs
		Array.from(document.querySelectorAll('.offers-nav-item')).forEach((el, idx) => {

			el.addEventListener('click', ev => {
				ev.preventDefault();
				const slideshow = el.closest('.listing-offers').querySelector('.slideshow');
				if (!slideshow) return false;

				let flkty = Flickity.data(slideshow);
				flkty.select(idx, true, false);

				getSiblings(el).map(e => e.classList.remove('active'));

				el.classList.add('active');

				if (window.innerWidth < 922) {
					slideshow.scrollIntoView({behavior: 'smooth'});
				}
			});

		});

		Array.from(document.querySelectorAll('[data-route-target]')).forEach(el => {
			el.addEventListener('click', ev => {
				ev.preventDefault();

				getSiblings(el).map(e => e.classList.remove('active'));

				el.classList.add('active');
				Array.from(document.querySelectorAll('.map-tab-container')).map( e => e.classList.remove('active'));
				document.querySelector(`[data-route="${el.dataset.routeTarget}"]`).classList.add('active');
			});
		});

		Array.from(document.querySelectorAll('[data-image-compare]')).map(el => new CompareImage(el));

		if (document.querySelector('.first-slideshow video')) {
			window.firstSlideshowVideo = new Video(document.querySelector('.first-slideshow video'));
		}

		if (document.querySelector('.video-embed')) {
			const videoEmbed = new EmbedVideo(document.querySelector('.video-embed'));
			window.onYouTubeIframeAPIReady = function() {
				videoEmbed.onYouTubeIframeAPIReady();
			}
		}

		const preloader = new Preloader();
		const fadeAnimation = new FadeAnimation();
		const scrollAnimation = new ScrollInAnimation();

		setTimeout(function() {
			window.dispatchEvent(new Event('resize'));
		}, 500);

		const egg = new Egg();
		egg.addCode('up,up,down,down,left,right,left,right,b,a', () => {
			document.body.classList.toggle('egged');
			setTimeout(function() {
				window.location = 'https://www.nelios.com';
			}, 2000);
		}).listen();
	}
};

domLoaded(() => {
	App.init();
});
